/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_CancelInputs */

const en_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_merge_swal_cancel = /** @type {(inputs: Merge_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Merge_Swal_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_cancel = /** @type {((inputs?: Merge_Swal_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_cancel(inputs)
	if (locale === "de") return de_merge_swal_cancel(inputs)
	if (locale === "it") return it_merge_swal_cancel(inputs)
	if (locale === "ru") return ru_merge_swal_cancel(inputs)
	if (locale === "es") return es_merge_swal_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_cancel(inputs)
	if (locale === "ja") return ja_merge_swal_cancel(inputs)
	if (locale === "hi") return hi_merge_swal_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_cancel(inputs)
	return en_merge_swal_cancel(inputs)
});